module.exports = __webpack_public_path__ + "img/Vector20.ca97400a.png";